import { render, staticRenderFns } from "./OrderPaymentStatusLabel.vue?vue&type=template&id=3b0c6025&scoped=true&"
import script from "./OrderPaymentStatusLabel.vue?vue&type=script&lang=js&"
export * from "./OrderPaymentStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./OrderPaymentStatusLabel.vue?vue&type=style&index=0&id=3b0c6025&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0c6025",
  null
  
)

export default component.exports